<template>
  <StepTitle>
    <div v-if="session && !session.enhanced_mode" v-html="session.label" class="how-can"></div>
    <template v-if="session && !session.enhanced_mode" #subtitle>
      <div v-html="session.subtitle"  class="option"></div>
    </template>
    <template v-if="session && session.content && session.content.length" #content>
      <b-row class="justify-content-md-center">
        <b-col v-if="!session.enhanced_mode" md="10" lg="8" xl="6" v-html="session.content"></b-col>
        <b-col v-if="session.enhanced_mode" v-html="session.content"></b-col>
      </b-row>
    </template>
  </StepTitle>
</template>

<script>
import { mapState } from 'vuex'
import StepTitle from './StepTitle'

export default {
  name: 'SessionContent',
  components: {StepTitle},
  computed: {
    ...mapState(['session'])
  }
}
</script>
<style scoped>
</style>
